import React from 'react';
import styles from "../app.module.scss";

export const ContentBox = ({children}: {children: React.ReactNode}) => {
  return (
      <div className={styles.contentBox}>
        {children}
      </div>
  );
}
